export default __webpack_public_path__ + "static/media/CancellOrderOff.eb448872.svg";